import { createContext } from "react";

export const AfpConsentLayoutContext = createContext<{
  label?: string;
  subLabel?: string;
}>({});
